import {
  getErrorMessage,
  getAuthenticationHeaders,
  getErrorMessageForBlob,
} from './utils';

import apiProvider from './provider';
import {
  FETCH_ALL_SHIPMENTS,
  POLL_SHIPMENTS,
  DOWNLOAD_SHIPMENT_CONTAINER_TRACKING,
  REFRESH_SHIPMENTS,
  DELETE_SHIPMENTS,
  SHARE_SHIPMENTS,
  ARCHIVE_SHIPMENT,
  SEND_SHIPMENT_DUMP,
  SEND_CONTAINER_DUMP,
  GET_TRACKING_REQUESTS,
  DISABLE_CONTAINER,
  DOWNLOAD_CONTAINER_TRACKING,
  GET_MULTIPLE_POLLING_BL_REQUESTS,
  GET_GLOBAL_CONTAINERS_COUNT,
  GET_REFRESH_CONTAINER_TRACKING,
  GET_REFRESH_BL_TRACKING,
  GET_CONTAINER_DETAILS_UUID,
  GET_CONTAINER_DETAILS_UUID_CONTAINER,
  GET_CONTAINER_DETAILS_CONTAINER,
  GET_CONTAINER_DETAILS,
  CONTAINER_TRACKING_REQUEST,
  UNARCHIVE_SHIPMENT,
  ADD_MANUAL_TRACKING_EVENT,
  GET_LAST_ACTIVITY_TRACKING_EVENT,
  GET_MANUAL_TRACKING_MASTER,
  EDIT_CT_BL,
  EDIT_CT_CONTAINER,
  EDIT_CT_SHIPMENT,
  DOWNLOAD_SAMPLE_TRACKING,
  SEARCH_INTERNAL_NUMBERS_CT,
  SEND_DSR_TRACKING_SHIPMENT_CUSTOMER,
  DOWNLOAD_CONTAINER_TRACKING_CONTAINER,
  ADD_SUBSCRIBER_CONTAINER_BULK_CN,
  ADD_SUBSCRIBER_CONTAINER_CN,
  ADD_SUBSCRIBER_CONTAINER_BULK,
  ADD_SUBSCRIBER_CONTAINER,
  DISABLE_CONTAINER_BY_CONTAINER,
  SHIPMENT_QUICK_ADD,
  GET_BL_LIST,
  GET_PORTS,
  GET_DISCHARGE_PORTS,
  GET_LOAD_PORTS,
  SHIPMENT_TRACKING_CONTAINER_POLL,
  INVOICE_SEARCH,
  INVOICE,
  FETCH_SHIPMENT_DETAILS,
  CREATE_SHIPMENT_OLD,
  GET_SHIPMENT_STATUSWISE_COUNT,
  UPDATE_SHIPMENT_DOCUMENTS,
  CT_CUSTOM_FIELDS,
  ADVISORY_FETCH,
  SEARCH_SHIPMENT_INVOICE,
  SEARCH_SHIPMENT_BY_TYPE,
  SEND_DSR_TRACKING_SHIPMENT_USER,
  SHIPMENT_QUICK_ADD_BULK,
  SHIPMENT_ADD_BULK_VALIDATE,
  POST_CONTAINER_RESET,
} from './routes';

import { API_BASE_URL } from '../globals';
import { POST, PATCH, DELETE, GET } from './apiHandler';
import {
  BLRequest,
  ContainerRequest,
  ShipmentRequest,
} from 'src/components/pages/Container/Interfaces/ShipmentRequests.interface';
import {
  BulkApiRequest,
  ArchiveRequest,
} from 'src/components/pages/Container/Interfaces/TypesInShipmentTracking';

export const getCustomFields = (params) => {
  return GET(`${API_BASE_URL}${CT_CUSTOM_FIELDS}`, params);
};

export const createShipmentOld = (body) => {
  return POST(`${API_BASE_URL}${CREATE_SHIPMENT_OLD}`, body);
};

export const editShipmentOld = (body) => {
  return PATCH(`${API_BASE_URL}${CREATE_SHIPMENT_OLD}`, body);
};

export const fetchShipmentDetailsApi = (params) => {
  return GET(`${API_BASE_URL}${FETCH_SHIPMENT_DETAILS}`, params);
};

export const invoiceSearch = (params) => {
  return GET(`${API_BASE_URL}${SHIPMENT_QUICK_ADD}${SEARCH_SHIPMENT_INVOICE}`, params);
};

export const searchShipmentByType = (params: { type: string, query: string }, signal?: AbortSignal) => {
  return GET(`${API_BASE_URL}${SEARCH_SHIPMENT_BY_TYPE}`, params, undefined, undefined, signal);
}

export const fetchAllShipments = async (params: ShipmentRequest) => {
  return POST(`${API_BASE_URL}${FETCH_ALL_SHIPMENTS}`, params);
};
export const getShipmentStatusWiseCount = async (params:  BLRequest | ContainerRequest | ShipmentRequest) => {
  return POST(`${API_BASE_URL}${GET_SHIPMENT_STATUSWISE_COUNT}`, params);
};
export const updateDocuments = async (params) => {
  return PATCH(`${API_BASE_URL}${UPDATE_SHIPMENT_DOCUMENTS}`, params);
}
export const editShipment = async (params) => {
  return PATCH(`${API_BASE_URL}${EDIT_CT_SHIPMENT}`, params);
}
export const getShipmentPollData = async (params: any) => {
  return POST(`${API_BASE_URL}${POLL_SHIPMENTS}`, params);
};

export const containerPoll = async (params) => {
  return POST(`${API_BASE_URL}${SHIPMENT_TRACKING_CONTAINER_POLL}`, params);
};

export const refreshShipments = async (shipments: string[]) => {
  return PATCH(`${API_BASE_URL}${REFRESH_SHIPMENTS}`, { shipmentIds: shipments });
};

export const disableShipments = async (shipments: string[]) => {
  return DELETE(`${API_BASE_URL}${DELETE_SHIPMENTS}`, { shipmentIdList: shipments });
};
export const disableBl = async (shipments: string[]) => {
  return DELETE(`${API_BASE_URL}${EDIT_CT_BL}`, { id: shipments });
};
export const disableContainer = async (shipments: string[]) => {
  return DELETE(`${API_BASE_URL}${EDIT_CT_CONTAINER}`, { containerId: shipments });
};

export const archiveShipment = async (shipmentList: ArchiveRequest) => {
  return PATCH(`${API_BASE_URL}${ARCHIVE_SHIPMENT}`, { ...shipmentList });
};

export const shareStatus = async (params) => {
  return POST(`${API_BASE_URL}${SHARE_SHIPMENTS}`, params);
};

export const applyFiltersToData = async (params: BLRequest) => {
  return POST(`${API_BASE_URL}${GET_TRACKING_REQUESTS}`, params);
};

export const disableContainers = async (params: { id: string[] }) => {
  return DELETE(`${API_BASE_URL}${DISABLE_CONTAINER}`, params);
};

export const getGlobalSummaryStats = async (blIdList: string[]) => {
  return POST(`${API_BASE_URL}${GET_MULTIPLE_POLLING_BL_REQUESTS}`, { blIdList });
};

export const getGlobalSummary = async (params) => {
  return POST(`${API_BASE_URL}${GET_GLOBAL_CONTAINERS_COUNT}`, params);
};

export const containerTrackingRefresh = async (params) => {
  return PATCH(`${API_BASE_URL}${GET_REFRESH_CONTAINER_TRACKING}`, params);
};

export const containerTrackingReset = async (params) => {
  return POST(`${API_BASE_URL}${POST_CONTAINER_RESET}`, params);
}

export const sendShipmentData = async (params) => {
  return POST(`${API_BASE_URL}${SEND_SHIPMENT_DUMP}`, params)
}

export const sendContainerData = async (params) => {
  return POST(`${API_BASE_URL}${SEND_CONTAINER_DUMP}`, params)
}

export const blTrackingRefresh = async (params) => {
  return PATCH(`${API_BASE_URL}${GET_REFRESH_BL_TRACKING}`, params);
};

export const blSearchApi = async (params, signal?: AbortSignal) => {
  return GET(`${API_BASE_URL}${GET_BL_LIST}`, params, undefined, undefined, signal);
};

export const quickAddBL = async (params) => {
  return POST(`${API_BASE_URL}${SHIPMENT_QUICK_ADD}`, params);
};

export const quickAddContainer = async (params) => {
  return POST(`${API_BASE_URL}${SHIPMENT_QUICK_ADD}`, params);
};

export const disableContainerByBLNumber = async (params) => {
  return DELETE(`${API_BASE_URL}${DISABLE_CONTAINER}`, params);
};

export const disableContainerByContainerNumber = async (params) => {
  return DELETE(`${API_BASE_URL}${DISABLE_CONTAINER_BY_CONTAINER}`, params);
};

export const updateEmailListBL = async (params) => {
  return PATCH(`${API_BASE_URL}${ADD_SUBSCRIBER_CONTAINER}`, params);
};

export const updateBulkEmailListBL = async (params) => {
  return PATCH(`${API_BASE_URL}${ADD_SUBSCRIBER_CONTAINER_BULK}`, params);
};

export const updateEmailListCN = async (params) => {
  return POST(`${API_BASE_URL}${ADD_SUBSCRIBER_CONTAINER_CN}`, params);
};

export const updateBulkEmailListCN = async (params) => {
  return POST(`${API_BASE_URL}${ADD_SUBSCRIBER_CONTAINER_BULK_CN}`, params);
};

export const sendDsrToCustomers = async (body) => {
  return POST(`${API_BASE_URL}${SEND_DSR_TRACKING_SHIPMENT_CUSTOMER}`, body);
};

export const sendDsrToUsers = async (body) => {
  return POST(`${API_BASE_URL}${SEND_DSR_TRACKING_SHIPMENT_USER}`, body);
}

export const searchInternalNumbers = async (body, signal?: AbortSignal) => {
  return GET(`${API_BASE_URL}${SEARCH_INTERNAL_NUMBERS_CT}`, body, undefined, undefined, signal);
};

export const fetchAdvisory = async () => {
  return GET(`${API_BASE_URL}${ADVISORY_FETCH}`);
};

export const editContainer = async (body) => {
  return PATCH(`${API_BASE_URL}${EDIT_CT_CONTAINER}`, body);
};

export const editBL = async (body) => {
  return PATCH(`${API_BASE_URL}${EDIT_CT_BL}`, body);
};

export const fetchManualTrackingMasterData = async (params) => {
  return GET(`${API_BASE_URL}${GET_MANUAL_TRACKING_MASTER}`, params);
};

export const fetchLastActivityTrackingEvent = async (params) => {
  return GET(`${API_BASE_URL}${GET_LAST_ACTIVITY_TRACKING_EVENT}`, params);
};

export const addManualTrackingEvent = async (body) => {
  return POST(`${API_BASE_URL}${ADD_MANUAL_TRACKING_EVENT}`, body);
};

export const unarchiveShipment = async (shipments) => {
  return PATCH(`${API_BASE_URL}${UNARCHIVE_SHIPMENT}`, { shipments });
};

export const getBLDetails = async (params) => {
  const { id } = params;
  return GET(`${API_BASE_URL}${GET_CONTAINER_DETAILS}`, { id });
};

export const getContainerList = async (params: ContainerRequest) => {
  return POST(`${API_BASE_URL}${CONTAINER_TRACKING_REQUEST}`, params);
};

export const getContainerDetails = async (params) => {
  return GET(
    `${API_BASE_URL}${GET_CONTAINER_DETAILS_CONTAINER}`,
    { containerIdList : params.id },
  );
};

export const getBLDetailsUUID = async (params) => {
  const { id } = params;
  return GET(`${API_BASE_URL}${GET_CONTAINER_DETAILS_UUID}?unique_id=${id}`);
};

export const getContainerDetailsUUID = async (params) => {
  const { id } = params;
  return GET(
    `${API_BASE_URL}${GET_CONTAINER_DETAILS_UUID_CONTAINER}?unique_id=${id}`,
    params,
  );
};

export const downloadBLs = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${DOWNLOAD_CONTAINER_TRACKING}`, params,
      {
        headers: getAuthenticationHeaders(),
        responseType: 'blob',
      },
    );
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadShipments = async(params: any) => {
  try {
    const response = await apiProvider.post(
        `${API_BASE_URL}${DOWNLOAD_SHIPMENT_CONTAINER_TRACKING}`,
        params,
      {
        headers: getAuthenticationHeaders(),
        responseType: 'blob',
      },
    );
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
      decodeURI(matches[1]) : '';
      filename = filename ? filename.replace(/"/g, '') : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
      contentType: response.headers['content-type'],
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getPorts = async (
  params: any = { queryString: ' ' },
  portApi: null | string = null,
) => {
  const apiURLMap = {
    loadport: GET_LOAD_PORTS,
    dischargeport: GET_DISCHARGE_PORTS,
  };
  return GET(
    `${API_BASE_URL}${(portApi && apiURLMap[portApi]) ? apiURLMap[portApi] : GET_PORTS}`,
    params,
  );
};

export const downloadSampleTracking = async (objectType?) => {
  try {
    const response = await apiProvider.get(
      `${API_BASE_URL}${DOWNLOAD_SAMPLE_TRACKING}`,
      {
        params: objectType ? {
          objectType,
        } : {},
        headers: getAuthenticationHeaders(),
        responseType: 'blob',
      },
    );
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
        decodeURI(matches[1]) : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const downloadContainers = async (params: any) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${DOWNLOAD_CONTAINER_TRACKING_CONTAINER}`, params,
      {
        headers: getAuthenticationHeaders(),
        responseType: 'blob',
      },
    );
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const matches = disposition.match(/filename="(.*)"/);
      filename = matches && matches.length && matches.length > 0 ?
        decodeURI(matches[1]) : '';
      filename = filename ? filename.replace(/"/g, '') : '';
    }
    return {
      filename,
      isSuccess: true,
      data: response.data,
      contentType: response.headers['content-type'],
    };
  } catch (error) {
    const errorMessage = await getErrorMessageForBlob(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const quickAddBLBulk = async (params) => {
  return POST(`${API_BASE_URL}${SHIPMENT_QUICK_ADD_BULK}`, params);
};

export const bulkValidate = async (params) => {
  return POST(`${API_BASE_URL}${SHIPMENT_ADD_BULK_VALIDATE}`, params);
}